import { Injectable } from "@angular/core";
import { ServiceType } from "./models/service/servicetype.model";

@Injectable()
export class PaymentType{
  constructor(){
    
  }
  getListPaymentType():ServiceType[]{
    let PaymentTypeList:ServiceType[]=[];
    PaymentTypeList.push( new ServiceType(1, 'Nạp tiền'));
    PaymentTypeList.push( new ServiceType(2, 'Bán hàng'));
    PaymentTypeList.push( new ServiceType(3, 'Chuyển tiền'));
    PaymentTypeList.push( new ServiceType(4, 'Hủy'));
    PaymentTypeList.push( new ServiceType(5, 'Hoàn tiền'));
    PaymentTypeList.push( new ServiceType(6, 'Rút tiền'));
    return PaymentTypeList;
  }
}
